<template>
    <div>
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="close">
            <a-form-model ref="ruleForm" :model="formData" :rules="rules" v-bind="layout">
                <a-form-model-item
                    ref="name"
                    label="版本名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name || formErr.name === "" ? "" : "error"'>
                    <a-input
                        :maxLength=80
                        v-model="formData.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  formData.name = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item
                    ref="abstract"
                    label="描述"
                    prop="abstract"
                    :help="formErr.abstract"
                    :validateStatus='!formErr.abstract || formErr.abstract === "" ? "" : "error"'>
                    <a-textarea :maxLength=200 :rows="4" v-model="formData.abstract"
                                @change="(e) => { formErr.abstract=''}"
                                @blur="(e) => {  formData.abstract = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status || formErr.status === "" ? "" : "error"'>
                    <a-radio-group v-model="formData.status">
                        <a-radio v-for="(item,index) in status_list" :value="item.id" :key="index"> {{
                                item.name
                            }}
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="handleSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="close">
                    取消
                </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import {drawerConfig, validator} from "@/utils/utils"
import API from "./api";

export default {
    name: "versionForm",
    props: [],
    data() {
        return {
            drawerConfig,
            title: '添加版本',
            visible: false,
            role: [],
            formData: {
                name: "",
                abstract: "",
                status: 1
            },
            formErr: {
                name: "",
                abstract: "",
                status: ""
            },
            rules: {
                name: [{required: true, message: "请输入版本名称 ",}, {
                    whitespace: true,
                    message: "请输入版本名称"
                }, {
                    validator: (rule, value, callback) => {
                        validator(rule, value, callback, this.formErr.name)
                    }, trigger: "blur"
                },]
            },
            layout: {
                labelCol: {span: 4},
                wrapperCol: {span: 14},
            },
            status_list: []
        };
    },
    watch: {},
    mounted() {
    },
    methods: {
        handleSubmit() {
            let _this = this;
            _this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let url = 'ADD_POST'
                    _this.formData.id == '' || _this.formData.id == undefined ? url = 'ADD_POST' : url = 'EDIT_POST'
                    API.service[url](this.formData).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success({content: res.data.msg, duration: 2})
                            this.close()
                            this.$emit("submitSuccess");
                        } else if (res.data.code == 400) {
                            res.data.msg.map((item) => {
                                _this.formErr[item.field] = item.msg
                            })
                        }
                    })
                }
            });
        },
        getAddInfo() {
            API.service.ADD().then(res => {
                if (res.data.code == 1) {
                    this.status_list = res.data.data.status_list;
                }
            })
        },
        getVersionInfo(data) {
            API.service.EDIT({
                id: data.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.status_list = res.data.data.status_list;
                    this.formData = res.data.data.info;
                }
            })
        },
        open(data) {
            this.visible = true;
            if (data) {
                this.getVersionInfo(data)
            } else {
                this.getAddInfo()
            }
        },
        close() {
            this.visible = false;
            this.formData = {
                name: "",
                abstract: "",
                status: 1
            }
            this.formErr = {
                name: "",
                abstract: "",
                status: ""
            }
            this.$refs.ruleForm.resetFields();
        }
    },
}
</script>

<style scoped>

</style>
